import type { AppVueRouter } from '@modules/core/services/router/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import {
  FINANCE_PERMISSIONS,
} from '@modules/finance/constants';
import { ADMIN_FINANCE_MONTH_ROUTE_NAME } from '@modules/finance/submodules/month-report/constants';

import {
  ADMIN_FINANCE_MONTH_DEDUCTION_ROUTE_NAME,
} from './constants';

export class FinanceMonthDeductionModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(ADMIN_FINANCE_MONTH_ROUTE_NAME, {
      name: ADMIN_FINANCE_MONTH_DEDUCTION_ROUTE_NAME,
      path: 'deduction/:id',
      permission: FINANCE_PERMISSIONS.SHOW,
      component: () => import('./pages/FinanceMonthDeductionPage/FinanceMonthDeductionPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(): void {
  }
}
